export const ENERGY_FORECAST_VALUE_UNIT = "GW";

// API values are in MW. These factors scale the raw MW data to the selected
// display unit (MW -> GW divides by 1000; MW stays unchanged).
export const ENERGY_UNIT_FACTORS = { GW: 0.001, MW: 1 } as const;
export type EnergyValueUnit = keyof typeof ENERGY_UNIT_FACTORS;

// Number of decimals to keep for energy values after unit scaling.
export const ENERGY_VALUE_DECIMALS = 3;

export const isEnergyValueUnit = (value: unknown): value is EnergyValueUnit =>
  typeof value === "string" && value in ENERGY_UNIT_FACTORS;

export const ECMWF_ENS_MODEL_ID = "ecmwf-ens";
export const DEFAULT_ENS_MEMBERS = ["mean"];

type EnergyPlotEnsMemberGroup = {
  model?: string | null;
  ensMembers?: string[] | null;
};

export function isEnergyPlotEnsModel(modelId?: string | null): boolean {
  return modelId === ECMWF_ENS_MODEL_ID;
}

export function normalizeEnergyPlotEnsMembers(group: EnergyPlotEnsMemberGroup): string[] | undefined {
  if (group.ensMembers && group.ensMembers.length > 0) {
    return group.ensMembers;
  }

  if (isEnergyPlotEnsModel(group.model)) {
    return [...DEFAULT_ENS_MEMBERS];
  }

  return undefined;
}
